import { LocalizedMatchEventWithMessage } from "../../../../apis/MatchAPI"
import moment from "moment"
import { LocalizedMatch } from "../../../../types/match"
import style from "./style.module.scss"
import { Row, Col } from "react-bootstrap"

export function MatchLiveTicker({
  match,
  events,
}: {
  match: LocalizedMatch
  events: LocalizedMatchEventWithMessage[]
}) {
  let missingEventsMessage
  if (moment(match.date).isAfter(moment())) {
    missingEventsMessage = "La partita non è ancora iniziata"
  } else {
    missingEventsMessage = "1' Inizio Partita"
  }
  return (
    <div className={style.matchLiveTickerMainContainer}>
      <Row>
        <Col>
          <h2>Eventi in diretta</h2>
        </Col>
      </Row>
      <div className={style.eventsContainer}>
        {events.length > 0
          ? events.map((event, i) => {
              return (
                <Row key={i} className={style.eventRow}>
                  <Col>
                    <Row className={style.matchLiveTickerEvent}>
                      <Col xs={2} sm={2} md={2} lg={2} xl={2} className={style.matchLiveTickerMinute}>
                        {event.minute ? event.minute : "1"}&apos;
                      </Col>
                      <Col xs={9} sm={9} md={9} lg={9} xl={9} className={style.matchLiveTickerContent}>
                        {event.message}
                      </Col>
                      <Col
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        className={"empty match_event-empty match_event-empty- match_event " + event.type}
                      ></Col>
                    </Row>
                  </Col>
                </Row>
              )
            })
          : missingEventsMessage}
      </div>
    </div>
    // <div className="hs-block hs-liveticker">
    //   <h2 className="hs-block-header marginZero">Eventi in diretta</h2>
    //   <div className="module-liveticker">
    //     <div>
    //       {events.length > 0
    //         ? events.map((event, index) => {
    //             return (
    //               <div key={index} className="liveticker" data-event_kind={event.type}>
    //                 <div className="liveticker-minute">{event.minute}</div>
    //                 {/* <div className="liveticker-datetime">{moment(event.date).format('HH:mm')}</div> */}
    //                 <div className={"empty match_event-empty match_event-empty- match_event " + event.type}></div>
    //                 <div className="liveticker-content">{event.message}</div>
    //               </div>
    //             )
    //           })
    //         : missingEventsMessage}
    //     </div>
    //   </div>
    // </div>
  )
}
